import dayjs from 'dayjs';
import { MemberPromotion } from '../model/pointofsale/MemberPromotion';

// Pure helpers for the "Add Promotion" modal's prior-promotion handling (FORT-316). The API returns
// history newest-first, but these don't rely on order.

// The member's most recently applied promotion, or null. Drives the informational note shown when a
// member has had ANY prior promotion.
export function mostRecentApplication(history: MemberPromotion[]): MemberPromotion | null {
    if (history.length === 0) return null;
    return history.reduce((latest, current) =>
        dayjs(current.appliedOn).isAfter(dayjs(latest.appliedOn)) ? current : latest);
}

// The most recent prior application of THIS promotion to the member, or null. Drives the
// same-promotion soft-block (a confirmation before re-applying).
export function lastApplicationOfPromotion(
    history: MemberPromotion[],
    promotionId: number,
): MemberPromotion | null {
    const matches = history.filter((h) => h.promotionId === promotionId);
    if (matches.length === 0) return null;
    return matches.reduce((latest, current) =>
        dayjs(current.appliedOn).isAfter(dayjs(latest.appliedOn)) ? current : latest);
}
